export default __webpack_public_path__ + "static/media/055.fe379127.jpeg";